import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  checkMenu,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editInbound,
  fetchIdInbound,
  fetchListInspection,
  fetchVehicle,
  fetchVehicleInboundWorkflow,
  selectIdInbound,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectPermissionList,
  selectTotalRecord,
  selectVehicle,
  setPermisionList,
  setPermisionPdiin,
  setPermisionPdiout,
  setPermisionRci,
  setPermisionStorage,
} from "./inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { RCIPage } from "./RCIPage.js";
import { PDIINPage } from "./PDIINPage";
import { PDIOUTPage } from "./PDIOUTPage";
import { TSAPage } from "./TSAPage";
import {
  fetchMenuTab,
  selectLoadingMenu,
  selectMenuTab,
} from "../menu/menuSlice";
import { ErrorPermissionPage } from "../../utility/ErrorPermissionPage";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const WorkflowEdit = (params) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdInbound);
  const data = useSelector(selectVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  const [paramFilter, setParamFilter] = useState("");
  const [paramValue, setParamValue] = useState("");

  // initial
  const dataParams = params.location.state;

  const dataMenuTab = useSelector(selectMenuTab);
  const loadingMenu = useSelector(selectLoadingMenu);
  const dataMenuList = useSelector(selectPermissionList);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      let result;

      if (dataParams === 0) {
        result = "1020,1040,2010,2011,2020";
      } else if (dataParams === 1) {
        result = "2030,3010,3020";
      } else if (dataParams === 2) {
        result = "3030,4010,4011,4020";
      } else if (dataParams === 3) {
        result = "4030,5010,5020";
      }

      await dispatch(
        fetchMenuTab({
          menu_url: "/inbound/overview",
        })
      );

      await dispatch(fetchIdInbound(id));
      setValue(dataParams);
      await dispatch(
        fetchVehicleInboundWorkflow({
          inbound_id: id,
          vehicle_status: result,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(fetchListInspection());

      await dispatch(
        fetchParameter({
          paramgroup_code: "VOLUME_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "WEIGTH_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "BASE_UOM",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "DISTANCE_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "RCI") {
          return dispatch(setPermisionRci(item.permissions));
        }
        if (item.menu_name === "PDI-In") {
          return dispatch(setPermisionPdiin(item.permissions));
        }
        if (item.menu_name === "PDI-Out") {
          return dispatch(setPermisionPdiout(item.permissions));
        }
        if (item.menu_name === "Storage") {
          return dispatch(setPermisionStorage(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setValueRci(0);
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    let result;

    if (value === 0) {
      result = "1020,1040,2010,2011,2020";
    } else if (value === 1) {
      result = "2030,3010,3020";
    } else if (value === 2) {
      result = "3030,4010,4011,4020";
    } else if (value === 3) {
      result = "4030,5010,5020";
    }

    let params = {};
    params.vehicle_status = result;
    params.inbound_id = id;
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleInboundWorkflow(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    console.log(newValue, "newValue");
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const [valueRci, setValueRci] = useState(0);

  const [formValues, setFormValues] = useState({
    vehicle_id: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    pdi_in_date: {
      value: "",
      error: false,
      required: "Y",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
  });
  const [formValuesPdiOut, setFormValuesPdiOut] = useState({
    vehicle_id: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    pdi_out_date: {
      value: "",
      error: false,
      required: "Y",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    inspection_results: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [formValuesRci, setFormValuesRci] = useState({
    vehicle_id: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },

    mileage: {
      value: "",
      error: false,
      required: "N",
    },
    engine_no: {
      value: "",
      error: false,
      required: "N",
    },
    key_no: {
      value: "",
      error: false,
      required: "N",
    },
    rci_date: {
      value: "",
      error: false,
      required: "Y",
    },
    inspection_result: {
      value: "",
      error: false,
      required: "Y",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    inbound_rule: {
      value: "N",
      error: false,
      required: "N",
    },
    validasi_action: {
      value: "N",
      error: false,
      required: "N",
    },
  });
  const [formValuesTSA, setFormValuesTSA] = useState({
    vehicle_id: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    location: {
      value: "",
      error: false,
      required: "Y",
    },
    location_name: {
      value: "",
      error: false,
      required: "Y",
    },
    storage_date: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [columnsInspection, setColumnsInspection] = useState([]);
  const [listInspection, setListInspection] = useState([]);
  const [detailDamage, setDetailDamage] = useState([]);
  const [rowInspection, setRowInspection] = useState(null);
  const [rowIndexInspection, setRowIndexInspection] = useState(null);

  const [show, setShow] = useState(false);
  const [showScan, setShowScan] = useState(false);
  const [showDetailDamage, setShowDetailDamage] = useState(false);
  const [create, setCreate] = useState(false);

  // formVehicle
  const [showVehicle, setShowVehicle] = useState(false);
  const [getData, setGetData] = useState(false);

  // initial
  const [formVehicle, setFormVehicle] = useState({
    master_code: {
      value: "",
      error: false,
      required: "Y",
    },
    master_code_name: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    model_code: {
      value: "",
      error: false,
      required: "N",
    },
    model_code_name: {
      value: "",
      error: false,
      required: "N",
    },

    model_name: {
      value: "",
      error: false,
      required: "N",
    },

    model_year: {
      value: "",
      error: false,
      required: "N",
    },
    engine_no: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    product_desc: {
      value: "",
      error: false,
      required: "N",
    },
    color_code: {
      value: "",
      error: false,
      required: "N",
    },
    color_code_name: {
      value: "",
      error: false,
      required: "N",
    },
    color_name: {
      value: "",
      error: false,
      required: "N",
    },
    production_date: {
      value: "",
      error: false,
      required: "N",
    },
    key_no: {
      value: "",
      error: false,
      required: "N",
    },
    baseuom: {
      value: "UNT",
      error: false,
      required: "N",
    },
    net_weight: {
      value: "",
      error: false,
      required: "N",
    },
    gross_weight: {
      value: "",
      error: false,
      required: "N",
    },
    weight_type: {
      value: "",
      error: false,
      required: "N",
    },
    length: {
      value: "",
      error: false,
      required: "N",
    },
    width: {
      value: "",
      error: false,
      required: "N",
    },
    heigth: {
      value: "",
      error: false,
      required: "N",
    },
    dimension_uom: {
      value: "",
      error: false,
      required: "N",
    },
    volume: {
      value: "",
      error: false,
      required: "N",
    },
    volume_uom: {
      value: "",
      error: false,
      required: "N",
    },
    inbound_rule: {
      value: "N",
      error: false,
      required: "N",
    },
  });

  // formVehicle
  const [showPrint, setShowPrint] = useState(false);
  const [getDataPrint, setGetDataPrint] = useState(false);
  const [labelTemplate, setLabeltemplate] = useState("");
  const [vehiclePrint, setVehiclePrint] = useState("");
  const [dataViewer, setDataViewer] = useState([]);
  const [pagePrint, setPagePrint] = useState(1);

  const [optionsList, setOptionsList] = useState([]);
  const [copy, setCopy] = useState(null);

  const [inspectoinResult, setInspectoinResult] = useState("OK");

  const [getDataProduct, setGetDataProduct] = useState(false);
  const [getDataColor, setGetDataColor] = useState(false);
  const [getDataModel, setGetDataModel] = useState(false);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Activity Monitor
                </p>
              </div>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Inbound Job : {dataId.inbound_name}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest  text-white ml-5">
                  Workflow
                </div>
              </div>
              <>
                <Tabs
                  value={value}
                  onChange={handleChangeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  {checkMenu(dataMenuList, "RCI") ? (
                    <Tab label={`RCI : ${dataId.rci_status} >`} />
                  ) : (
                    <Tab disabled label={`RCI : You Dont Have Permission >`} />
                  )}
                  {checkMenu(dataMenuList, "PDI - In") ? (
                    <Tab label={`PDI-In : ${dataId.pdiin_status} >`} />
                  ) : (
                    <Tab
                      disabled
                      label={`PDI - In : You Dont Have Permission >`}
                    />
                  )}

                  {checkMenu(dataMenuList, "PDI - Out") ? (
                    <Tab label={`PDI - Out : ${dataId.pdiout_status} >`} />
                  ) : (
                    <Tab
                      disabled
                      label={`PDI - Out : You Dont Have Permission >`}
                    />
                  )}

                  {checkMenu(dataMenuList, "Storage") ? (
                    <Tab label={`Storage : ${dataId.storage_status} `} />
                  ) : (
                    <Tab
                      disabled
                      label={`Storage : You Dont Have Permission >`}
                    />
                  )}
                </Tabs>
                {value === 0 && (
                  <>
                    {checkMenu(dataMenuList, "RCI") ? (
                      <RCIPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueRci}
                        setValue={setValueRci}
                        formValues={formValuesRci}
                        setFormValues={setFormValuesRci}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        showDetailDamage={showDetailDamage}
                        setShowDetailDamage={setShowDetailDamage}
                        create={create}
                        setCreate={setCreate}
                        columnsInspection={columnsInspection}
                        setColumnsInspection={setColumnsInspection}
                        listInspection={listInspection}
                        setListInspection={setListInspection}
                        detailDamage={detailDamage}
                        setDetailDamage={setDetailDamage}
                        rowInspection={rowInspection}
                        setRowInspection={setRowInspection}
                        rowIndexInspection={rowIndexInspection}
                        setRowIndexInspection={setRowIndexInspection}
                        showVehicle={showVehicle}
                        setShowVehicle={setShowVehicle}
                        formVehicle={formVehicle}
                        setFormVehicle={setFormVehicle}
                        getData={getData}
                        setGetData={setGetData}
                        showPrint={showPrint}
                        setShowPrint={setShowPrint}
                        getDataPrint={getDataPrint}
                        setGetDataPrint={setGetDataPrint}
                        labelTemplate={labelTemplate}
                        setLabeltemplate={setLabeltemplate}
                        vehiclePrint={vehiclePrint}
                        setVehiclePrint={setVehiclePrint}
                        dataViewer={dataViewer}
                        setDataViewer={setDataViewer}
                        copy={copy}
                        setCopy={setCopy}
                        getDataProduct={getDataProduct}
                        setGetDataProduct={setGetDataProduct}
                        getDataModel={getDataModel}
                        setGetDataModel={setGetDataModel}
                        getDataColor={getDataColor}
                        setGetDataColor={setGetDataColor}
                        optionsList={optionsList}
                        setOptionsList={setOptionsList}
                        pagePrint={pagePrint}
                        setPagePrint={setPagePrint}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
                {value === 1 && (
                  <>
                    {checkMenu(dataMenuList, "PDI - In") ? (
                      <PDIINPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueRci}
                        setValue={setValueRci}
                        formValues={formValues}
                        setFormValues={setFormValues}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        showDetailDamage={showDetailDamage}
                        setShowDetailDamage={setShowDetailDamage}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
                {value === 2 && (
                  <>
                    {checkMenu(dataMenuList, "PDI - Out") ? (
                      <PDIOUTPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueRci}
                        setValue={setValueRci}
                        formValues={formValuesPdiOut}
                        setFormValues={setFormValuesPdiOut}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        showDetailDamage={showDetailDamage}
                        setShowDetailDamage={setShowDetailDamage}
                        create={create}
                        setCreate={setCreate}
                        columnsInspection={columnsInspection}
                        setColumnsInspection={setColumnsInspection}
                        listInspection={listInspection}
                        setListInspection={setListInspection}
                        detailDamage={detailDamage}
                        setDetailDamage={setDetailDamage}
                        rowInspection={rowInspection}
                        setRowInspection={setRowInspection}
                        rowIndexInspection={rowIndexInspection}
                        setRowIndexInspection={setRowIndexInspection}
                        inspectoinResult={inspectoinResult}
                        setInspectoinResult={setInspectoinResult}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
                {value === 3 && (
                  <>
                    {checkMenu(dataMenuList, "Storage") ? (
                      <TSAPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueRci}
                        setValue={setValueRci}
                        formValues={formValuesTSA}
                        setFormValues={setFormValuesTSA}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        showDetailDamage={showDetailDamage}
                        setShowDetailDamage={setShowDetailDamage}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
              </>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};
